import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Container,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";

export default function DeviceSelect({
  deviceSelect,
  setDeviceSelect,
}: {
  deviceSelect: {
    device: string;
    os: string;
  };
  setDeviceSelect: React.Dispatch<
    React.SetStateAction<{
      device: string;
      os: string;
    }>
  >;
}) {
  const [osOptions, setOsOptions] = useState<string[] | undefined>(undefined);
  const handleDeviceSelect = (e: React.ChangeEvent<{ value: unknown }>) => {
    setDeviceSelect({ os: "", device: e.target.value as string });
    if (["タブレット", "スマートフォン"].includes(e.target.value as string)) {
      setOsOptions(["Android", "iOS"]);
    } else {
      setOsOptions(["Windows", "Mac"]);
    }
  };
  const handleOsChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    console.log(e.target.value);
    setDeviceSelect((prevState) => {
      return { ...prevState, os: e.target.value as string };
    });
  };
  return (
    <Box className="section-50" component={"section"}>
      <Container className="container">
        <Typography component={"h2"} className="section-heading">
          【任意】お問い合わせ端末
        </Typography>
        <Grid container alignItems="center" spacing={2}>
          <Grid item md={6} style={{ flex: 1 }}>
            <FormControl variant="outlined" style={{ width: "100%" }}>
              <InputLabel id="device-select">お問い合わせ端末</InputLabel>
              <Select
                labelId="device-select"
                id="device-select"
                value={deviceSelect.device}
                onChange={handleDeviceSelect}
                style={{ width: "100%" }}
                label="お問い合わせ端末"
              >
                <MenuItem value={"PC"}>PC</MenuItem>
                <MenuItem value={"スマートフォン"}>スマートフォン</MenuItem>
                <MenuItem value={"タブレット"}>タブレット</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={6} style={{ flex: 1 }}>
            <FormControl
              variant="outlined"
              style={{ width: "100%" }}
              disabled={deviceSelect.device === ""}
            >
              <InputLabel id="os-select">お問い合わせOS</InputLabel>
              <Select
                labelId="os-select"
                id="os-select"
                value={deviceSelect.os}
                onChange={handleOsChange}
                style={{ width: "100%" }}
                label="お問い合わせOS"
              >
                {osOptions &&
                  osOptions.map((osOption, i) => (
                    <MenuItem value={osOption} key={i}>
                      {osOption}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
